import { type FC } from "react";

import { Tooltip } from "@snapchat/snap-design-system";
import { InformationIcon } from "@snapchat/snap-design-system-icons";

interface TooltipIconProps {
    content: string;
}

export const InfoTooltip: FC<TooltipIconProps> = ({ content }) => (
    <Tooltip content={content}>
        <InformationIcon />
    </Tooltip>
);
